import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import {
  AreaChart, Area, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid,
} from "recharts";
import Logo from "@/components/brand/Logo";

export default function PublicReportPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/public/reports/${id}/latest`).then(({ data }) => setData(data));
  }, [id]);

  if (!data) return <div className="bg-ivory-50 min-h-screen flex items-center justify-center text-navy-900">Loading…</div>;

  return (
    <div className="bg-ivory-50 min-h-screen text-navy-900" data-testid="public-report">
      <header className="px-6 sm:px-12 py-6 border-b border-border bg-white flex items-center justify-between">
        <Logo variant="dark" />
        <span className="editorial-overline">Public growth snapshot</span>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <p className="editorial-overline">{data.project_name}</p>
        <h1 className="font-serif text-5xl mt-3 leading-tight">{data.website_url}</h1>
        <p className="text-muted-foreground mt-5 leading-relaxed">{data.executive_summary}</p>

        <div className="bg-white border border-border rounded-sm p-7 mt-10">
          <p className="editorial-overline">Traffic trend</p>
          <div className="h-72 mt-4">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data.traffic_trend}>
                <CartesianGrid stroke="#E5E0D5" vertical={false} />
                <XAxis dataKey="date" tickFormatter={(d) => d.slice(5)} fontSize={11} />
                <YAxis fontSize={11} />
                <Tooltip />
                <Area type="monotone" dataKey="views" stroke="#C5A059" fill="rgba(197,160,89,0.18)" strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mt-6">
          {data.highlights.map((h) => (
            <div key={h} className="bg-white border border-border rounded-sm p-5">
              <p className="font-serif text-lg">{h}</p>
            </div>
          ))}
        </div>
      </main>

      <footer className="px-6 sm:px-12 py-6 border-t border-border bg-white text-sm text-muted-foreground">
        Generated by TrendRise AI · trendrise.ai
      </footer>
    </div>
  );
}
